import { useEffect, useMemo, useRef } from 'react'

import { type Column, Table } from '../../../../../../components/Table'
import { useInfiniteScroll } from '../../../../../../hooks/useInfiniteScroll'
import { useInfiniteClientesQuery } from '../../../../../../services/hooks/clients/queries/useClientsQuery'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'

type Props = {
  filters: FiltersDomain
  columns: Column[]
}

export const TableWithInfiniteScroll = ({ filters, columns }: Props) => {
  const tableContainerRef = useRef<HTMLDivElement>(null)

  const {
    data,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    refetch
  } = useInfiniteClientesQuery(filters)

  const rows = useMemo(() => {
    return (
      data?.pages?.reduce((acc: any, item: any) => {
        return [...acc, ...item.data]
      }, []) || []
    )
  }, [data?.pages])

  useInfiniteScroll(tableContainerRef, hasNextPage, fetchNextPage)

  useEffect(() => {
    refetch()
  }, [])

  return (
    <Table
      columns={columns}
      rows={rows}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      tableContainerRef={tableContainerRef}
      noContentMessage="Sem registro de cliente(s)"
      paginationMode="scroll"
    />
  )
}
